import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { getPanelBasePath } from "@/lib/authz";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@/components/ui/command";
import {
  LayoutDashboard,
  ShoppingCart,
  Package,
  Users,
  FileText,
  BarChart3,
  Settings,
  Plug,
  Warehouse,
  Receipt,
  Tag,
  Truck,
  Building2,
} from "lucide-react";

const NAV_ITEMS = [
  { label: "Dashboard", path: "", icon: LayoutDashboard, group: "Sayfalar" },
  { label: "Siparişler", path: "/siparisler", icon: ShoppingCart, group: "Sayfalar" },
  { label: "Ürünler", path: "/urunler", icon: Package, group: "Sayfalar" },
  { label: "Müşteriler", path: "/musteriler", icon: Users, group: "Sayfalar" },
  { label: "Faturalar", path: "/faturalar", icon: FileText, group: "Sayfalar" },
  { label: "Raporlar", path: "/raporlar", icon: BarChart3, group: "Sayfalar" },
  { label: "Stok", path: "/stok", icon: Warehouse, group: "Sayfalar" },
  { label: "Tedarikçiler", path: "/tedarikciler", icon: Building2, group: "Sayfalar" },
  { label: "Masraflar", path: "/masraflar", icon: Receipt, group: "Sayfalar" },
  { label: "Entegrasyonlar", path: "/entegrasyonlar", icon: Plug, group: "Ayarlar" },
  { label: "Genel Ayarlar", path: "/ayarlar", icon: Settings, group: "Ayarlar" },
  { label: "Kargo Etiket", path: "/kargo", icon: Truck, group: "İşlemler" },
  { label: "Abonelik", path: "/abonelik", icon: Tag, group: "Ayarlar" },
];

export default function CommandPalette() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, []);

  const handleSelect = useCallback(
    (path) => {
      setOpen(false);
      const base = getPanelBasePath(user);
      navigate(`${base}${path}`);
    },
    [navigate, user]
  );

  const groups = NAV_ITEMS.reduce((acc, item) => {
    if (!acc[item.group]) acc[item.group] = [];
    acc[item.group].push(item);
    return acc;
  }, {});

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Sayfa veya özellik ara..." />
      <CommandList>
        <CommandEmpty>Sonuç bulunamadı.</CommandEmpty>
        {Object.entries(groups).map(([group, items], i) => (
          <div key={group}>
            {i > 0 && <CommandSeparator />}
            <CommandGroup heading={group}>
              {items.map((item) => (
                <CommandItem
                  key={item.path}
                  value={item.label}
                  onSelect={() => handleSelect(item.path)}
                  className="gap-2 cursor-pointer"
                >
                  <item.icon className="h-4 w-4 text-muted-foreground" />
                  {item.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </div>
        ))}
      </CommandList>
    </CommandDialog>
  );
}
